module.exports = __webpack_public_path__ + "img/top6_right.96bfcb5e.png";